import * as Single from './redux';

export {
  Single,
};



// WEBPACK FOOTER //
// ./modules/SingleFlight/index.js